import { createSlice } from "@reduxjs/toolkit";

export const pointReversalSlice = createSlice({
  name: "point-reversal-",
  initialState: {
    isLoading: false,
    isError: false,
    pointReversalData: [],
    message: "",
  },
  reducers: {
    onPostPointReversal: (state) => {
      return {
        ...state,
        isPostLoading: true,
        pointReversalData: [],
        postmessage: "",
      };
    },

    onPostPointReversalSuccess: (state, { payload }) => {
      const { data = [], message = "", status_code = 200 } = payload;
      return {
        ...state,
        isPostLoading: false,
        pointReversalData: data,
        postmessage: message,
        post_status_code: status_code,
      };
    },

    onPostPointReversalError: (state, { payload }) => {
      const { data = [], message = "", status_code = 400 } = payload;
      return {
        ...state,
        pointReversalData: data,
        postmessage: message,
        post_status_code: status_code,
        isPostLoading: false,
      };
    },
    onPostPointReversalReset: (state) => {
      return {
        ...state,
        post_status_code: null,
        isPostLoading: false,
      };
    },
  },
});

export const {
  onPostPointReversal,
  onPostPointReversalSuccess,
  onPostPointReversalError,
  onPostPointReversalReset,
} = pointReversalSlice.actions;

export default pointReversalSlice.reducer;
